import { BaseUrlService } from './base-url.service';

export class ValidationService {
    static $inject: string[] = ['$http', 'BaseUrlService'];

    private baseUrl: any;

    constructor(
        private $http: ng.IHttpService,
        private _baseUrlService: BaseUrlService,
    ) {
        this.baseUrl = _baseUrlService.getBaseUrl();
    }

    validateUserFieldUniqueness(path: any, value: any) {
        return this.$http.get(this.baseUrl + '/validate/field/' + path + '/' + value);
    }

    isUsersPivaOrFiscalCodeMatchingWithOdinProvisioningInformation(user: any) {
        return this.$http.post(this.baseUrl + '/validate/odin-provisioning/piva-or-fiscal-code', user);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/validation.service.ts